/**
 * The words of the wizard's «Delivery» block on the ad-group step (PR 6). What X does is
 * quoted from `audits/2026-10-23/x-reference-line-item-delivery-verbatim.md` (R:/G:); what
 * this console does is said as its own.
 */
import type { DeliveryProblem } from "./line-item-delivery.ts";

export const DELIVERY_HEADING = "Delivery";

export const DELIVERY_HELP =
	"Every field here is optional, and a field left empty is not sent — X then applies its own setting.";

export const CAP_LABEL = "Frequency cap";
export const CAP_HELP =
	"X: «The maximum number of times an ad could be delivered to a user.» With it, the window it applies to.";
export const WINDOW_LABEL = "Within";
export const WINDOW_NAMES: Readonly<Record<string, string>> = {
	"1": "1 day",
	"7": "7 days",
	"30": "30 days",
};

/** Under WEBSITE_CLICKS the cap is not shown; this says why. */
export const CAP_NOT_FOR_OBJECTIVE =
	"No frequency cap under this objective — X: «Only supported for REACH, ENGAGEMENTS, VIDEO_VIEWS, and PREROLL_VIEWS objectives».";

export const EXPANSION_LABEL = "Audience expansion";
export const EXPANSION_NONE = "Not sent — X: «By default, no expansion will be applied.»";
/** 🔴 The three values are X's; their meaning is not: the reference describes none of them. */
export const EXPANSION_HELP =
	"X: «Used to expand the reach of campaigns by targeting users similar to those already targeted.» X's reference lists BROAD, DEFINED and EXPANDED and does not say what each one does.";

export const PACING_LABEL = "Pacing";
export const PACING_NONE = "Not sent — X's default (standard, by its guide)";
export const PACING_STANDARD = "Standard — X: «ensures an even spend rate throughout the day»";
export const PACING_ACCELERATED =
	"Accelerated — X: «we will serve impressions and generate engagements as quickly as possible until your daily budget is exhausted»";
/** Why pacing may be refused, and that it is fixed once sent. */
export const PACING_HELP =
	"Only with the budget on each ad group — X: «Only available when budget_optimization is set to LINE_ITEM for the parent campaign». Chosen once: X's reference has no such parameter on a line item's update.";

export const DELIVERY_PROBLEMS: Readonly<Record<DeliveryProblem, string>> = {
	"cap-without-window":
		"Choose the window too: this console sends the cap and its window together — X's reference names no rule, and its only example sends both.",
	"window-without-cap":
		"Give the cap too, or clear the window: this console sends the two together.",
	"cap-invalid":
		"The cap is a whole number of 1 or more — this console's rule; X's reference names no bound.",
};
